import { render, staticRenderFns } from "./ReceiveDetail.vue?vue&type=template&id=669e0550&scoped=true&"
import script from "./ReceiveDetail.vue?vue&type=script&lang=js&"
export * from "./ReceiveDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveDetail.vue?vue&type=style&index=0&id=669e0550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669e0550",
  null
  
)

export default component.exports